import { LevelCatalog, SuspendedLevel, isNormalisedRun, recordOwnedTowers, runProfileFor } from "@highmarch/app";
import { BalanceData, DailyRoad, LevelModifiers, LevelSim, dailyRoad, profilePower, utcDay } from "@highmarch/domain";

/**
 * The level flow's fair-mode and Daily Road glue (MP-20, MP-32; docs/MODES.md §4), kept apart from boot/levelFlow.ts:
 * which towers a run loads, the power its HUD shows, the timer reduction it pays and the road PLAY AGAIN starts.
 */

/** The towers a run deals (their models load): a resumed run's own, a fair run's normalised ones, else the player's. */
export function runOwned(catalog: LevelCatalog, resume: SuspendedLevel | null, modifiers: LevelModifiers | null): boolean[] {
  return resume ? recordOwnedTowers(catalog.balance, resume.record) : [...runProfileFor(catalog, modifiers).owned];
}

/** The HUD's power line: a fair run's normalised power, else the player's. */
export function runPower(catalog: LevelCatalog, modifiers: LevelModifiers | null): number {
  return isNormalisedRun(catalog.balance, modifiers) ? profilePower(catalog.balance, runProfileFor(catalog, modifiers)) : catalog.profile.powerScore;
}

/** The level a run's timer reduction pays at: a Daily Road, event-mode or challenge run at the player's own progress, not the layout it borrowed. */
export function reductionLevel(sim: LevelSim | undefined, level: number, catalog: LevelCatalog): number {
  return sim?.isDaily === true || sim?.isEventRun === true || sim?.isChallenge === true ? Math.max(1, Math.min(level, catalog.highestLevelCleared)) : level;
}

/** Today's road: PLAY AGAIN on Daily Road (practice once the day is paid; the new day's road after midnight). */
export function todaysRoad(balance: BalanceData, now: number): DailyRoad { return dailyRoad(balance, utcDay(now)); }
